import { translate } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { otp } from './otp-config.js';
import { userLabel } from './user-label-config.js';

function getTotpFormConfig(errorMessage) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, [
                    {
                        name: 'totp',
                        path: 'totp',
                        components: [otp(), userLabel()],
                        errorMessage: errorMessage,
                        nextButton: {
                            text: translate('otp.button'),
                            alwaysEnabled: true,
                        },
                    },
                ]];
        });
    });
}

export { getTotpFormConfig };
